import React, {Component} from 'react';
import Slider from 'react-slick';
import {Field, reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {
    login
} from '../../actions/Index';
import {renderPasswordInputField, renderEmailInputField} from '../Layout/FormInputs'
import {toastr} from 'react-redux-toastr';
import {langs} from '../../config/localization';
import Modal from '../Elements/Modal';
import {getAuthUserDetails} from "../../actions/Common";
import {Loader} from "../Common/Loader";

class SignupSuccess extends Component {

    constructor(props) {
        super(props);
        this.state = {
            toggleModal     : false,
            modalType       : '',
            username        : '',
            accessToken     : '',
            tokenType       : '',
            showLoader      : false,
            userId: getAuthUserDetails().id
        };
    }
    
    /**
     * Close modal
     */
    closeModal() {
        this.setState({toggleModal : false});
    }

    /**
     * Render the login form
     * @returns {*}
     */
    render(){
       
        const {handleSubmit} = this.props;
        const TopSliderSettings = {
            arrows: true,
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipe:false,
            autoplay: false,
            responsive: [
                {
                breakpoint: 768,
                settings: {
                    arrows: true,
                }
            },
            
        ]
        };
        if(!this.state.showLoader) {
            return (               
                <section className="section-login">
                    <div className="row">
                        <div className="medium-12 columns">
                            <div className="login-wrapper">
                                <div className="login-container">
                                    <div className="login-left primary-gradient-bg">
                                        <div className="globe-bg">
                                            <h2>Welcome to earthDECKS</h2>
                                        </div>
                                        <div className="map-bg">
                                            <img src="assets/images/eathdeck/map.png" />
                                        </div>
                                    </div>
                                    <div className="login-right welcome-page">
                                        <div className="icon-form text-center">
                                            <a href={`/set-password?uid=''?token=''`}> <img src="assets/images/eathdeck/email_link.png" /></a>
                                        </div>
                                        <div className="login-form">
                                            <div className="form-group text-center">
                                                <p className="check-link">Check your email for your "complete sign-up" link</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                
            );
        } else {
            return <Loader/>
        }
    }
}

/**
 * Form validations
 * @param values
 * @returns {{}}
 */
function validate(values){
    let errors = {};
    return errors;
}

export default reduxForm({
    validate,
    form: 'Login'
})(
    connect(null, {login})(SignupSuccess)
);


// WEBPACK FOOTER //
// ./components/Auth/SignupSuccess.js